import Emitter from './emitter'

const TIMING = {
  STD_ANIM_TIME: 250, // this should be kept in parity with the CSS $speed-1 variable
  SLOW_ANIM_TIME: 500, // this should be kept in parity with the CSS $speed-2 variable
  SLOWER_ANIM_TIME: 835, // this should be kept in parity with the CSS $speed-3 variable
  TIMEOUT: 6000, // used for navigation preview
  RESIZE_THROTTLE: 100
}

export const GLOBAL_CONSTANTS = {
  UTILS: {
    EMITTER: Emitter
  },
  CLASSES: {
    ACTIVE: '-active',
    LOADED: 'is-loaded',
    HIDE: '-hide',
    SHOW: '-show',
    OPEN: '-open',
    PLAYING: '-playing',
    DRAGGING: '-dragging'
  },
  EVENTS: {
    CLICK: 'click',
    ENDED: 'ended',
    KEYDOWN: 'keydown',
    LOAD: 'load',
    LAZY_LOADED: 'lazyloaded',
    MOUSEENTER: 'mouseenter',
    MOUSELEAVE: 'mouseleave',
    FOCUSIN: 'focusin',
    FOCUSOUT: 'focusout',
    REDUCED_MOTION_CHANGE: 'reduced-motion-change',
    INCREASE_CONTRAST_CHANGE: 'increase-contrast-change',
    FORCED_COLORS_CHANGE: 'forced-colors-change',
    LOW_POWER_MODE: 'low-power-mode',
    RESIZE: 'resize',
    SCROLL: 'scroll',
    ELEMENT_IN_VIEWPORT: 'element-in-viewport',
    PRIDE_DATA_LOADED: 'pride-data-loaded',
    IS_MOBILE: 'is-mobile',
    XRAY_IS_ACTIVE: 'xray-active',
    XRAY_IS_DRAGGING: 'xray-dragging',
    AUDIO_TRANSCRIPT_TOGGLE: 'audio-transcript',
    MODAL_OPENED: 'modal-opened',
    MODAL_CLOSED: 'modal-closed'
  },
  TIMING,
  COLORS: {
    black: '#000',
    blueblack: '#091f2c',
    gray: '#727272',
    lightgray: '#ccc',
    offwhite: '#f4f3f5',
    white: '#fff',
    // YELLOW
    lightyellow: '#ffe399',
    yellow: '#ffb900',
    darkyellow: '#7f5a1a',
    // ORANGE
    lightorange: '#ffa38b',
    orange: '#ff5c39',
    darkorange: '#73391d',
    // RED
    lightred: '#ffb3bb',
    red: '#f4364c',
    darkred: '#73262f',
    // MAGENTA
    lightmagenta: '#d59ed7',
    magenta: '#c03bc4',
    darkmagenta: '#702573',
    // PURPLE
    lightpurple: '#c5b4e3',
    purple: '#8661c5',
    darkpurple: '#463668',
    // BLUE
    lightblue: '#8dc8e8',
    blue: '#0078d4',
    darkblue: '#2a446f',
    // TEAL
    lightteal: '#b9dcd2',
    teal: '#49c5b1',
    darkteal: '#225b62',
    // GREEN
    lightgreen: '#d4ec8e',
    green: '#8de971',
    darkgreen: '#07641d'
  },
  BREAKPOINTS: {
    mobile: 767
  }
}
